export default __webpack_public_path__ + "static/media/push31.2413721c.gif";